export default [
  {
    path: '/no-permission',
    name: 'np-permission',
    component: () => import('@/views/common/noPermission'),
    meta: {
      title: '无权限！'
    }
  },
  {
    path: '/only-qyweixn',
    name: 'only-qyweixn',
    component: () => import('@/views/common/onlyQyWeixin'),
    meta: {
      title: '该小程序仅适用于企业微信'
    }
  }
]
